import {useAuthStore} from '@/stores/auth.store'
import {FetchWrapper} from "@/types/fetchWrapper.type"
import {Keyable} from "@/types/keyable.type"
import {safeStringify} from "@/helpers/safeStringify"

export const fetchWrapper: FetchWrapper = {
    get: request('GET'),
    post: request('POST'),
    patch: request('PATCH'),
    delete: request('DELETE')
}

function request(method: string): (url: string, body?: object, parameters?: Keyable, files?: object, accept?: string) => Promise<string> {
    return (url: string, body?:object, parameters?: Keyable, files?: object, accept?: string) => {
        const requestOptions: Keyable = {
            method,
            credentials: 'include',
        }
        if (body) {
            if(accept != undefined) {
                requestOptions.headers = {
                    "Accept": accept,
                }
            }else{
                requestOptions.headers = {}
            }
            if(method === 'GET' || method === 'DELETE' || method === 'POST') requestOptions.headers['Content-Type'] = 'application/ld+json'
            else requestOptions.headers['Content-Type'] = 'application/merge-patch+json'
            requestOptions.body = safeStringify(body)
        }
        if(parameters) {
            const searchParams: URLSearchParams = new URLSearchParams()
            for (const key in parameters) {
                if(typeof parameters[key] !== 'object') {
                    searchParams.append(key, parameters[key])
                }else{
                    for (const childKey in parameters[key]) {
                        searchParams.append(key + '[' + childKey + ']', parameters[key][childKey])
                    }
                }
            }
            url += '?' + searchParams.toString()
        }

        if(files){
            requestOptions.body = new FormData()
            for (const [key, value] of Object.entries(files)) {
                if (value instanceof File) {
                    requestOptions.body.append(key, value);
                }
            }
            requestOptions.body.append('data', safeStringify(body))
            delete requestOptions.headers['Content-Type']
        }
        return fetch(url, requestOptions).then(handleResponse)
    }
}

function handleResponse(response: Response): Promise<string> {
    return response.text().then(text => {
        const data = text && JSON.parse(text)

        if (!response.ok) {
            const { user, logout } = useAuthStore()
            if ([401, 403].includes(response.status) && user) {
                logout()
            }

            const error = (data && data.message) || (data && data.detail) || response.statusText
            return Promise.reject(error)
        }else{
            return data
        }
    })
}